import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class ProductFormDetailForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'detaljer-formater', dataApiName: 'ProductFormDetail', text: 'Detaijer, formater', textSingular: "Detaljer, format",
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      }, fieldMetadata: [
        { name: 'isDigital', text: 'Er digital', tooltipText: 'Er udgivelser af denne type digital (modsat fysisk)', format: 'CheckBox' },
        { name: 'onix', text: 'ONIX' }
      ]
    });
  }
}
